import Menu, { MenuItem, SubMenu, ShareMenu } from '@/components/Menu/';
import Dropdown from '@/components/Dropdown/Dropdown';
import { getNormalPageUrl, getNoteSharedUrl, getPNSettingPageUrl } from '@/utils/urlHelper';
import { getState } from '@/reducers/NoteContent/NoteContentReducer';
import { getState as getNotebooksState } from '@/reducers/Notebooks/NotebooksReducer';
import {
  publishNote,
  privateNote,
  deleteNoteSoft,
  moveNote,
  sortNotes,
  postSetNoteTop,
  postUnsetNoteTop,
  setNoteReprintAble,
} from '@/actions/NotesAction';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { is } from 'immutable';
import i18n from 'react-intl-universal';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { SortableElement, arrayMove } from 'react-sortable-hoc';
import { getState as globalState } from '@/reducers/Global/GlobalReducer';
import { setSortedNoteData, openTimePublishBuyModalAction } from '../../../actions/GlobalAction';
import ajax from '../../../utils/ajax';
import styles from './NoteItem.scss';
import Modal from '../../../components/Modal';
import Message from '../../Message';
import TimePublishModal from '../../../components/TimePublishModal/TimePublishModal';
import { getState as getUserState } from '../../../reducers/User/UserReducer';
import { JIANSHU_EDITOR } from '../../../constants/variables';
import { martinDispatch } from '../../../utils/util';

@SortableElement
@withRouter
@connect(
  state => ({
    content: getState(state),
    notebooksState: getNotebooksState(state),
    userInfo: getUserState(state).get('user'),
    globalState: globalState(state),
  }),
  dispatch => ({
    setSortedNoteData: data => dispatch(setSortedNoteData(data)),
    moveNote: (nbId, newNbId, noteId, doneCallback) => {
      dispatch(moveNote(nbId, newNbId, noteId, doneCallback));
    },
    $setNoteReprintAble: noteId => dispatch(setNoteReprintAble(noteId)),
    publishNote: noteId => dispatch(publishNote(noteId)),
    $openTimePublishBuyModal: data => dispatch(openTimePublishBuyModalAction(data)),
    privateNote: noteId => dispatch(privateNote(noteId)),
    sortNotes: (oldSeq, newSeq, nbId) => dispatch(sortNotes(oldSeq, newSeq, nbId)),
    deleteNoteSoft: (nbId, noteId, doneCallback) => {
      dispatch(deleteNoteSoft(nbId, noteId, doneCallback));
    },
    postSetNoteTop: (noteId) => {
      return martinDispatch(dispatch, postSetNoteTop(noteId));
    },
    postUnsetNoteTop: (noteId) => {
      return martinDispatch(dispatch, postUnsetNoteTop(noteId));
    },
  }),
)
export default class NoteItem extends Component {
  static propTypes = {
    note: PropTypes.object,
    active: PropTypes.bool,
    preNoteId: PropTypes.number,
    nextNoteId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.menuItems = [
      {
        icon: 'share',
        text: i18n.get('note-action.publicize'),
        action: 'publish-note', // 执行的动作
        noteStatus: 'private&!paid', // 拥有这个选项的文章状态, 支持&|
      },
      {
        icon: 'clock-o',
        text: i18n.get('note-action.time-publish'),
        action: 'time-publish-note', // 定时发文
        noteStatus: '!paid&private&!schedule_publish_at', // 付费文章不做
      },
      {
        iconfont: 'paid',
        text: i18n.get('note-action.publicize-paid-note'),
        action: 'publish-pay-note',
        // 只有私密+付费、非连载+从来未公开的文章才可以发布付费文章
        // 如果设置了定时发文，也不能发布付费文章
        noteStatus: 'private&paid|!inbook&!compiled&!schedule_publish_at',
      },
      {
        icon: 'check',
        text: i18n.get('note-action.publicized'),
        noteStatus: 'shared', // 拥有这个选项的文章状态
      },
      {
        iconfont: 'paid',
        text: i18n.get('note-action.compile-paid-note'),
        action: 'compile-pay-note',
        noteStatus: 'paid&shared',
      },
      {
        iconfont: 'set',
        text: i18n.get('note-action.set-publicize-style'),
        action: 'publish-style',
        noteStatus: 'any', // 拥有这个选项的文章状态
      },
      {
        iconfont: 'icon_stick',
        text: i18n.get('note-action.topping-note'),
        action: 'topping-note',
        noteStatus: 'shared&!istop',
      },
      {
        iconfont: 'icon_stick',
        text: i18n.get('note-action.untopping-note'),
        action: 'untopping-note',
        noteStatus: 'istop',
      },
      {
        isShareMenu: true,
        icon: 'share',
        text: i18n.get('note-action.share'),
        noteStatus: 'shared', // 拥有这个选项的文章状态
      },
      {
        icon: 'folder-open',
        text: i18n.get('note-action.move-note'),
        action: 'move-note',
        noteStatus: 'any', // 拥有这个选项的文章状态
      },
      {
        icon: 'external-link',
        text: i18n.get('note-action.open-in-new-window'),
        action: 'open-in-new-window',
        noteStatus: 'shared', // 拥有这个选项的文章状态
      },
      {
        icon: 'lock',
        text: i18n.get('note-action.private-note'),
        action: 'private-note',
        noteStatus: 'shared', // 拥有这个选项的文章状态
      },
      {
        icon: 'history',
        text: i18n.get('note-action.to-history'),
        action: 'to-history',
        noteStatus: 'any', // 拥有这个选项的文章状态
      },
      {
        icon: 'trash-o',
        text: i18n.get('note-action.del-note'),
        action: 'del-note',
        noteStatus: 'any', // 拥有这个选项的文章状态
      },
      {
        icon: 'ban',
        text: i18n.get('note-action.set-unreprintable'),
        action: 'set-reprintable',
        noteStatus: 'reprintable',
      },
      {
        icon: 'ban',
        text: i18n.get('note-action.cancel-unreprintable'),
        action: 'set-reprintable',
        noteStatus: '!reprintable',
      },
    ];
    this.state = {
      showTimePublishModal: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const isNoteChanged = !(is(this.props.note, nextProps.note) &&
      this.props.active === nextProps.active);
    const isContentChanged = !is(this.props.content, nextProps.content);
    const isUserInfoChanged = !is(this.props.userInfo, nextProps.userInfo);

    const sortingNote = nextProps.globalState.get('sortingNote').toJS();
    const { newNbId, noteId, nbId } = sortingNote;
    const curNoteId = nextProps.note.get('id');
    if (noteId === +curNoteId && newNbId && nbId && +nbId !== +newNbId) {
      this.moveNote(nbId, newNbId, noteId, nextProps);
      // reset the data
      this.props.setSortedNoteData({});
    }
    // eslint-disable-next-line max-len
    return (
      isUserInfoChanged ||
      isContentChanged ||
      isNoteChanged ||
      !_.isEqual(this.state, nextState)
    );
  }

  navNote = () => {
    const { note, history, match } = this.props;
    const noteId = note.get('id');
    const { params: { nbId } } = match;
    if (+noteId !== +match.params.noteId) {
      history.push(`/notebooks/${nbId}/notes/${noteId}`);
    }
  };
  moveNote = (nbId, newNbId, noteId, props = this.props) => {
    this.props.moveNote(nbId, newNbId, noteId, (error) => {
      if (error) {
        return;
      }
      Message.success(i18n.get('notes.move-note-success'));
      this.autoGotoNextNote(nbId, props);
    });
  }
  // 跳转到下一篇或者上一篇
  autoGotoNextNote = (nbId, props) => {
    const { preNoteId, nextNoteId, history } = props;
    const { match: { params: { noteId } } } = props;
    // 避免push相同的path
    if (+noteId !== +preNoteId) {
      history.replace(getNormalPageUrl(nbId, nextNoteId || preNoteId));
    } else {
      history.replace(getNormalPageUrl(nbId));
    }
  };

  delNote = (nbId, noteId, title, props = this.props) => {
    Modal.Confirm(i18n.get('notes.del-note-confirm-tip', { title }), {
      onOk: () => {
        this.props.deleteNoteSoft(nbId, noteId, (error, data) => {
          // 删除文章的回调
          if (error) {
            Message.error(i18n.get('error.try-again'));
            return;
          }
          this.autoGotoNextNote(nbId, props);
        });
      },
      onCancel: () => {
      },
    });
  };

  // 开始设置
  openTimePublishModal = () => {
    this.setState({
      showTimePublishModal: true,
    });
  };

  closeTimePublishModal = () => {
    this.setState({
      showTimePublishModal: false,
    });
  };

  // 定时发文
  timePublish = () => {
    const { userInfo } = this.props;
    const isMember = userInfo.has('member');
    // 是会员直接可以设置
    if (isMember) {
      this.openTimePublishModal();
    } else {
      ajax.getTimePublishCount().then(({ data }) => {
        // 如果不是会员，则需要判断次数
        if (data.quantity > 0) {
          this.openTimePublishModal();
        } else {
          Message.warning('您当前的定时发文功能权益次数不足，请支付购买');
          ajax.getTimePublishCardInfo().then((res) => {
            this.props.$openTimePublishBuyModal(res.data);
          });
        }
      });
    }
  };

  // 调用editor的方法, 这样方便和editor保持行为一致
  callEditorFunction = (name, ...args) => {
    const editorInstance = window[JIANSHU_EDITOR];
    if (editorInstance && editorInstance[name]) {
      editorInstance[name](...args);
    }
  }
  toppingNote = (nbId, noteId) => {
    const { notebooksState } = this.props;
    const oldSeq = notebooksState.getIn(['entities', nbId.toString(), 'notes']).toJS();
    const oldIndex = oldSeq.indexOf(noteId);
    JsSensor.trackEvent(SAEVENTS.PC_CLICK_STICK);
    this.props.postSetNoteTop(noteId).then(() => {
      if (oldIndex !== 0) {
        const newSeq = arrayMove(oldSeq, oldIndex, 0);
        this.props.sortNotes(oldSeq, newSeq, nbId);
      }
      Message.success(i18n.get('note-action.topping-success'));
    });
  }
  untoppingNote = (noteId) => {
    JsSensor.trackEvent(SAEVENTS.PC_CLICK_UNSTICK);
    this.props.postUnsetNoteTop(noteId).then(() => {
      Message.success(i18n.get('note-action.untopping-success'));
    });
  }
  onDropDownItemClick = (e, data) => {
    const { note, history } = this.props;
    const noteId = note.get('id');
    const title = note.get('title');
    const nbId = note.get('notebook_id'); // 当前文章所在的文集
    const actionData = data.index || {};
    // 移动文章本身的item不需要响应
    if (actionData.action === 'move-note') {
      return;
    }
    switch (actionData.action) {
      case 'publish-note': {
        this.callEditorFunction('publicizeNote', noteId);
        break;
      }
      case 'private-note':
        this.props.privateNote(noteId);
        break;
      case 'set-reprintable': {
        this.props.$setNoteReprintAble(noteId);
        break;
      }
      case 'time-publish-note': {
        this.timePublish();
        break;
      }
      case 'del-note':
        this.delNote(nbId, noteId, title);
        break;
      // 移动文章，点击文集后
      case 'move-note-done':
        this.moveNote(nbId, actionData.nbId, noteId);
        break;
      case 'open-in-new-window':
        window.open(getNoteSharedUrl(note.get('slug')));
        break;
      case 'to-history':
        history.push(`/notebooks/${nbId}/notes/${noteId}/history`);
        break;
      case 'publish-pay-note':
        this.canPublishPadiNote();
        break;
      case 'compile-pay-note':
        this.callEditorFunction('publicizePaidNote', nbId, noteId, true);
        break;
      case 'topping-note':
        this.toppingNote(nbId, noteId);
        break;
      case 'untopping-note':
        this.untoppingNote(noteId);
        break;
      case 'publish-style':
        if (note.get('shared')) {
          JsSensor.trackEvent(SAEVENTS.PUBLIC_NOTE);
        } else {
          JsSensor.trackEvent(SAEVENTS.PRIVATE_NOTE);
        }
        history.push(`/notebooks/${nbId}/notes/${noteId}/pssetting`);
        break;
      default:
        break;
    }
    document.body.click(); // close the drop menu
  };
  renderNotebookListMenu = () => {
    const { notebooksState, note } = this.props;
    const curNbId = note.get('notebook_id');
    const seq = notebooksState.get('seq').toJS();
    const entities = notebooksState.get('entities').toJS();
    return seq.filter(v => v !== curNbId).map((v, k) => {
      return (
        <MenuItem
          key={k}
          index={{ action: 'move-note-done', nbId: v }} // 点击动作信息，在click handle中会收到
          title={entities[v].name}
        >
          {entities[v].name}
        </MenuItem>
      );
    });
  };

  // eslint-disable-next-line class-methods-use-this
  check(dataArray = [], checkArray = []) {
    const left = dataArray.indexOf(checkArray[0]) > -1;
    if (checkArray.length < 3) {
      return left;
    }
    const ops = checkArray[1];
    const rightArray = checkArray.slice(2);
    if (ops === '|') {
      return left || this.check(dataArray, rightArray);
    }
    if (ops === '&') {
      return left && this.check(dataArray, rightArray);
    }
    return left;
  }

  getNoteStatusArray = () => {
    const { note } = this.props;
    const noteStatus = note.get('shared') ? ['shared'] : ['private'];
    noteStatus.push('any');
    // 是否是付费文章
    if (note.get('paid')) {
      noteStatus.push('paid');
    } else {
      noteStatus.push('!paid');
    }
    // 是否发布过
    if (note.get('last_compiled_at') > 0) {
      noteStatus.push('compiled');
    } else {
      noteStatus.push('!compiled');
    }
    // 是否是连载
    if (note.get('in_book')) {
      noteStatus.push('inbook');
    } else {
      noteStatus.push('!inbook');
    }
    // 是否置顶
    if (note.get('is_top')) {
      noteStatus.push('istop');
    } else {
      noteStatus.push('!istop');
    }
    // 禁止转载，哪个傻逼写的这种判断代码，一个判断条件手动需要加一次，一点可维护性都没有
    if (note.get('reprintable')) {
      noteStatus.push('reprintable');
    } else {
      noteStatus.push('!reprintable');
    }
    // 定时发文
    if (note.get('schedule_publish_at')) {
      noteStatus.push('schedule_publish_at');
    } else {
      noteStatus.push('!schedule_publish_at');
    }
    return noteStatus;
  };

  getMenuItems = () => {
    const { note, userInfo } = this.props;
    const { menuItems } = this;
    const noteStatusArray = this.getNoteStatusArray();
    // 只有当前文章的状态有资格拥有这个menuItem时才渲染menuItem
    return menuItems.filter((menuItem) => {
      if (menuItem.action === 'publish-style' && !userInfo.get('can_update_cover_images')) {
        return false;
      }
      const checkArray = menuItem.noteStatus.split(/(\||&)/);
      return this.check(
        noteStatusArray,
        checkArray,
      );
    }).map((menuItem, menuItemIndex) => {
      // 分享数据
      const shareD = {
        link: getNoteSharedUrl(note.get('slug')),
        title: note.get('title'),
        text: note.get(),
      };
      const actionData = {
        action: menuItem.action,
        nbId: note.get('notebook_id'),
      };
      // 发布付费文章的权限
      if (menuItem.action === 'publish-pay-note') {
        return (
          <MenuItem
            key={menuItemIndex}
            index={actionData}
            iconName={menuItem.icon}
            iconFontName={menuItem.iconfont}
            disabled={!userInfo.get('can_publish_paid_note')}
          >
            {menuItem.text}
          </MenuItem>
        );
      }
      // 分享选项
      if (menuItem.isShareMenu) {
        return (
          <ShareMenu
            shareData={shareD}
            key={menuItemIndex}
            index={actionData}
            text={menuItem.text}
            iconName={menuItem.icon}
          />
        );
      }

      // 移动文章
      if (menuItem.action === 'move-note') {
        return (
          <SubMenu
            index={actionData}
            key={menuItemIndex}
            iconName={menuItem.icon}
            text={menuItem.text}
            className={styles['move-note-item']}
          >
            {this.renderNotebookListMenu()}
          </SubMenu>
        );
      }
      // 普通选项
      return (
        <MenuItem
          key={menuItemIndex}
          index={actionData} // 点击动作信息，在click handle中会收到
          iconName={menuItem.icon}
          iconFontName={menuItem.iconfont}
        >
          {menuItem.text}
        </MenuItem>
      );
    });
  };

  // 从redux 中获取content
  getNoteContent = (noteId) => {
    const { content } = this.props;
    if (noteId) {
      return {
        content: content.getIn(['entities', noteId, 'content']),
        abbr: content.getIn(['entities', noteId, 'abbr']),
        wordNum: content.getIn(['entities', noteId, 'wordNum']),
      };
    }
    return {};
  };
  canPublishPadiNote = () => {
    const { note, userInfo } = this.props;
    const noteId = note.get('id');
    const nbId = note.get('notebook_id');
    // const badge = userInfo.getIn(['jsd_level_for_paid_note', 'name']);
    const minJSD = userInfo.getIn(['jsd_level_for_paid_note', 'min_score']);
    if (!userInfo.get('can_publish_paid_note')) {
      Modal.open(
        (
          <Fragment>
            <p className={styles['paid-note-modal-content']}>
              {i18n.get('pay-note.publish-explain-1')}
            </p>
            <p className={styles['paid-note-modal-content']}>
              {i18n.get('pay-note.publish-explain-2', { minJSD: (minJSD / 1000).toFixed(0) })}
            </p>
            <div className={styles['paid-note-modal-btn']}>
              <a
                className={styles['paid-note-modal-btn-about']}
                href={'/mobile/fp/growth'}
                target='_blank'
              >{i18n.get('pay-note.about-jsd')}
              </a>
              <a
                className={styles['paid-note-modal-btn-buy']}
                href={'/mobile/club'}
                target='_blank'
              >{i18n.get('pay-note.open-js-member')}
              </a>
            </div>
          </Fragment>
        ), {
          showFooter: false,
          title: i18n.get('pay-note.publish-paid-notes'),
          headerStyle: { textAlign: 'center' },
          tips: false,
          width: 360,
          top: '30%',
        },
      );
    } else {
      this.callEditorFunction('publicizePaidNote', nbId, noteId);
    }
  }

  render() {
    const { note, active, match, preNoteId, nextNoteId, content } = this.props;
    const { params: { noteId } } = match;
    const title = note.get('title');
    const noteContent = this.getNoteContent(noteId);
    const { abbr, wordNum } = noteContent;
    const shared = note.get('shared');
    const paid = note.get('paid');
    const audioIcon = content.getIn(['entities', noteId, 'audio']) === undefined ? false : content.getIn(['entities', noteId, 'audio', 'title']) !== undefined;

    const itemClass = classNames({
      [`${styles['note-item']}`]: true,
      [`${styles['note-item-active']}`]: active,
    });
    const iconClass = classNames({
      [styles['note-icon-private']]: !paid,
      [styles['note-icon-shared']]: !paid && shared,
      iconfont: paid,
      'ic-paid': paid,
      [styles['note-icon-paid']]: paid,
      [styles['note-icon-paid-shared']]: paid && shared,
    });
    return (
      <li className={itemClass} onClick={this.navNote} title={title}>
        <i className={iconClass}/>
        {
          // dropdown不支持show prop, 采用每次都重新挂在的方式，
          // 因为每一个dropdown多会有个window click的事件监听, 多了不好
          active &&
          <Dropdown
            className={styles['dropdown']}
            menuItems={this.getMenuItems()}
            sortable
            onItemClick={this.onDropDownItemClick}
          />
        }
        <span className={styles.title}>
          {
            note.get('is_top') &&
            <span className={styles.topTag}>
              {i18n.get('notes.topping')}
            </span>
          }
          {title}
        </span>
        {
          active &&
          <span className={styles.abbr}>
            {
              audioIcon &&
              <span className={classNames('fa', 'fa-volume-up', styles.audio)}>
                {i18n.get('notes.audio')}<span className={styles.dot}/>
              </span>
            }
            {abbr}
          </span>
        }
        {
          active &&
          <span className={styles['word-num']}>
            {i18n.get('notes.word-num')}
            {wordNum}
          </span>
        }
        <TimePublishModal
          noteId={noteId}
          visible={this.state.showTimePublishModal}
          onClose={this.closeTimePublishModal}
        />
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoteList/NoteItem/NoteItem.js